import { create } from 'zustand'

import { SdkAdapter } from '../adapters/sdk-adapter'
import { type SdkAdapterInterface } from '../adapters/sdk-adapter.interface'

type DeviceFingerPrintType = {
  isLoading: boolean
  error?: string
  sdkInstance: SdkAdapterInterface
}

type DeviceFingerPrintState = {
  setValues: ({ isLoading, error }: Omit<DeviceFingerPrintType, 'sdkInstance'>) => void
} & DeviceFingerPrintType

const sdkInstance = new SdkAdapter()

export const useDeviceFingerPrintStore = create<DeviceFingerPrintState>(set => ({
  isLoading: true,
  error: undefined,
  sdkInstance: sdkInstance,
  setValues: ({ isLoading, error }) =>
    set({
      isLoading,
      error
    })
}))
